import { createContext, useContext } from "react";

export const McaEditorReadOnlyContext = createContext(false);

export const useMcaEditorReadOnly = () => useContext(McaEditorReadOnlyContext);
